import React, { useMemo } from 'react';
import { Box, Container, Title, Text } from '@firsttable/web-components/atoms';
import { getUserCity } from '@firsttable/functions';
import type { City } from '@firsttable/types';
import type { SpaceProps } from 'styled-system';
import { TrackProvider } from '@components/analytics/context/AnalyticsContext';
import HeroBackgroundImage from '../../molecules/HeroBackgroundImage';
import HomeSearchForm from '../Forms/HomeSearchForm';

const HomePageHero = ({
  regions,
  countryStates,
  marginBottom,
}: {
  regions: { edges: City[] };
  countryStates: { cities?: { menuTitle?: string; slug?: string }[] }[];
  marginBottom?: SpaceProps['mb'];
}) => {
  const city = useMemo(() => getUserCity(), []);

  return (
    <HeroBackgroundImage {...(marginBottom != null ? { mb: marginBottom } : {})}>
      <Container>
        <Title
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          textAlign="center"
          mb="20px"
          mx="auto"
          size="hero"
          as="h1"
          color="white"
          maxWidth={700}
          data-textnodetype="h1">
          Dine early and save 50% off your food bill
        </Title>
        <Text
          color="white"
          fontSize="19px"
          display="flex"
          justifyContent="center"
          textAlign="center"
          mb="65px"
          maxWidth={700}
          mx="auto"
          data-textnodetype="p">
          Book a first table at thousands of restaurants and enjoy 50% off the food bill!
        </Text>

        <Box position="relative">
          <TrackProvider component_name="search form">
            <HomeSearchForm
              subCities={regions}
              countryStates={countryStates}
              initialValues={{ city }}
            />
          </TrackProvider>
        </Box>
      </Container>
    </HeroBackgroundImage>
  );
};

export default HomePageHero;
